import { RegisterNewCompanyMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const registerNewCompanyHandler =
  graphql.mutation<RegisterNewCompanyMutation>(
    "registerNewCompany",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          registerNewCompany: {
            result: true,
          },
        },
      });
    }
  );
